import { Instagram, MessageCircle, Music2 } from "lucide-react";
import { IG_URL, WA_URL } from "./data";

export const Footer = () => (
    <footer className="border-t border-[#DDB56C]/15 bg-[#071B37] pb-28 pt-14 lg:pb-14" data-testid="site-footer">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <div className="flex flex-col items-center gap-8 text-center">
                <p className="font-accent text-xl font-semibold tracking-[0.18em] text-white" data-testid="footer-logo">
                    CICI <span className="text-[#DDB56C]">DEVELOPER</span>
                </p>
                <div className="flex flex-wrap items-center justify-center gap-4" data-testid="footer-socials">
                    <a href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram"
                        className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm text-white/80 transition-colors duration-300 hover:border-[#DDB56C]/60 hover:text-[#DDB56C]">
                        <Instagram className="h-4 w-4" strokeWidth={1.5} /> @cici.developer
                    </a>
                    <a href={WA_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp"
                        className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm text-white/80 transition-colors duration-300 hover:border-[#DDB56C]/60 hover:text-[#DDB56C]">
                        <MessageCircle className="h-4 w-4" strokeWidth={1.5} /> 0878 6717 7527
                    </a>
                    <a href="https://www.tiktok.com/@cicideveloper" target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok"
                        className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm text-white/80 transition-colors duration-300 hover:border-[#DDB56C]/60 hover:text-[#DDB56C]">
                        <Music2 className="h-4 w-4" strokeWidth={1.5} /> @cicideveloper
                    </a>
                </div>
                <div className="gold-hairline h-px w-full max-w-md" />
                <p className="max-w-xl text-xs leading-relaxed text-white/45" data-testid="footer-disclaimer">
                    Materi kelas bersifat edukatif dan tidak menjamin persetujuan KPR atau hasil finansial tertentu.
                </p>
                <p className="text-xs text-white/45" data-testid="footer-copyright">
                    © 2026 Cici Developer. All rights reserved.
                </p>
            </div>
        </div>
    </footer>
);
